<template>
  <div class="mobile_toc_container">
    <div class="d-flex-row justify-start flex-7">
      <BurgerIcon />
      <p class="t-light font-family-2 regular-xl">
        {{ $t("blog.on_this_page") }}
      </p>
    </div>
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      @click="toggleOpen"
    >
      <path
        d="M4 8.3252H20M4 16.3252H20"
        stroke="#d0d6e0"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <div
      class="d-flex-column justify-start align-start page_nav_container"
      v-if="isOpen"
    >
      <button
        class="context-h2 active font-family-2 regular-l nav-item"
        v-for="(h2el, index) in h2Content"
        :key="h2el.h2"
        @click="navToEl(h2el?.content, index)"
      >
        {{ getH2Title(h2el?.content) }}
      </button>
    </div>
  </div>
</template>

<script setup>
import BurgerIcon from "../icons/blog/BurgerIcon.vue";
import Hamburger from "../icons/Hamburger.vue";

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};

const isOpen = ref(false);
const props = defineProps({
  blog: {
    default: null,
  },
});

const h2Content = computed(() => {
  if (!props.blog) return [];
  return generateTableOfContents(props.blog?.content);
});
function generateTableOfContents(sanityBlocks) {
  try {
    let h3Elements = [];

    sanityBlocks?.forEach((block, index) => {
      if (block.style === "h3") {
        h3Elements.push(index);
      }
    });
    const h2Elements = sanityBlocks
      .map((item, index) => {
        if (item.style === "h2") {
          return { h2: index, content: item, h3: [] }; // Include an empty h3 array
        }
        return null;
      })
      .filter(Boolean);
    // Populate h3 inside the correct h2
    for (let i = 0; i < h2Elements.length; i++) {
      const currentH2Index = h2Elements[i].h2;
      const nextH2Index = h2Elements[i + 1]?.h2; // Get next H2 index
      h2Elements[i].h3 = [];
      const relyingElements = h3Elements
        .filter((el) => el > currentH2Index && el < nextH2Index)
        .map((el) => sanityBlocks[el]);

      if (relyingElements.length > 0) {
        h2Elements[i].h3 = [...relyingElements];
      }
    }

    return h2Elements;
  } catch (error) {
    console.log(error);
    return [];
  }
}

function getH2Title(h2El) {
  const content = h2El?.children?.map((span) => span.text).join("") || "";
  return content;
}

const navToEl = (h2El, index) => {
  const elId = generateSlug(getH2Title(h2El));
  const el = document.getElementById(`link-${elId}`);
  const navEl = document.getElementById(`nav-${elId}`);
  toggleOpen();
  if (el) {
    const headerOffset = 160; // Adjust for fixed header
    const elementPosition = el.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};
const generateSlug = (text) => {
  return text
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "");
};
</script>

<style lang="scss">
.mobile_toc_container {
  position: fixed;
  min-height: 60px;
  width: 100%;
  display: flex;
  margin-left: -1rem;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
  background-color: #08090a !important;

  & > * {
    z-index: 1;
  }
  &::before {
    content: "";
    height: 100%;
    width: 100%;
    background: rgba(5, 6, 7, 0.3);
    backdrop-filter: blur(7.5px);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  z-index: 100;
  .page_nav_container {
    position: absolute;
    top: 100%;
    left: 0%;
    min-height: 100px;
    height: max-content;
    padding: 12px 14px;
    background-color: #08090a !important;
    width: 100%;
    max-height: 600px;
  }
}
</style>
